/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ reason: NonNullable<unknown> }} Sorx_Undelivered_OneInputs */

const en_sorx_undelivered_one = /** @type {(inputs: Sorx_Undelivered_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`1 message not delivered: ${i?.reason}`)
};

const id_sorx_undelivered_one = /** @type {(inputs: Sorx_Undelivered_OneInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`1 pesan tidak terkirim: ${i?.reason}`)
};

/**
* | output |
* | --- |
* | "1 message not delivered: {reason}" |
*
* @param {Sorx_Undelivered_OneInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const sorx_undelivered_one = /** @type {((inputs: Sorx_Undelivered_OneInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sorx_Undelivered_OneInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sorx_undelivered_one(inputs)
	return en_sorx_undelivered_one(inputs)
});